module.exports = __webpack_public_path__ + "img/check-mark.946fb7df.svg";